function roundKidHours(n) {
  return Math.round(Number(n || 0) * 100) / 100;
}

export function getEventKidHoursRecord(ev) {
  if (ev == null) return 0;
  if (ev.impact_hours_record != null && Number.isFinite(Number(ev.impact_hours_record))) {
    return roundKidHours(ev.impact_hours_record);
  }
  return 0;
}

export function getEventKidHoursEntered(ev) {
  if (ev == null) return 0;
  if (ev.impact_hours_entered != null && Number.isFinite(Number(ev.impact_hours_entered))) {
    return roundKidHours(ev.impact_hours_entered);
  }
  return 0;
}

export function getEventKidHoursTotal(ev) {
  return roundKidHours(getEventKidHoursRecord(ev) + getEventKidHoursEntered(ev));
}

export function formatKidHours(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";
  return n.toFixed(2);
}
